import React from 'react';
import { AvailableRoutes } from '../../AppRoutes';
import { Redirect } from 'react-router-dom';

const Admin = (): JSX.Element => <Redirect to={AvailableRoutes.dataAnonymization} />;

export default Admin;
